import { Injectable } from '@angular/core';
import { Category as CoreCategory, ICategoryData } from '@df/catalog/category/category';
import { TLoadDependeciesParams } from '@df/catalog/model';
import { Resource } from '@df/catalog/resource';
import { NgInject } from '@df/ng/ng-inject';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
export class Category<T extends ICategoryData = ICategoryData> extends CoreCategory<T> {
    /**
     * Load cms block servoce
     */
    @NgInject(ICmsBlockResource)
    private iCmsBlockResource!: ICmsBlockResource;
    /**
     * Extra dependencies
     */
    protected override addDependenciesToLoader(params: TLoadDependeciesParams): void {
        super.addDependenciesToLoader(params);
        const loader = params.loader;
        if ((this.verbosity || 0) > 2) {
            loader.add(
                new Promise<void>(resolve => {
                    this.iCmsBlockResource
                        .retrieve({ bareUrl: 'category-page-layout', variant: this.lpLayoutVariant }, undefined)
                        .finally(() => resolve());
                })
            );
        }

    }
    /**
     * Category page layout variant
     */
    get lpLayoutVariant(): string {
        return this.data?.id + '';
    }
}
@Injectable({
    providedIn: 'root'
})
export class LocalCategoryResource extends Resource<Category, number> {
    static override instance = Category;
    readonly invalidatesUniversal = true;
    readonly invalidatesPrerender = true;
}
